import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { IAddress } from '@cemex-core/cmx-api/models/address/address.interface';
import {
  ADDRESS_NAMES_ADD_ENTITY,
  LOAD,
  LOAD_ADDRESS,
  LOAD_ADDRESS_NAMES_SUCCESS,
  LOAD_ADDRESS_SUCCESS,
  LOAD_COMPLETE,
  LOAD_INITIAL_STATE,
  LOAD_SALES_AREA_SUCCESS,
  NEW_POINT_OF_DELIVERY_CREATED,
  NEW_POINT_OF_DELIVERY_FAIL,
  POD_SET_AVAILABILITY,
  POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS,
  POINT_OF_DELIVERY_SET,
  PointOfDeliveryActions,
  PONT_OF_DELIVERY_DELETE_BY_ID,
  REMOVE_SELECTED_POD,
  RESET_NEW_POINT_OF_DELIVERY,
  TOGGLE_SHOWING_POD_REQUESTS,
} from '../../actions/point-of-delivery-actions/point-of-delivery.actions';
import { IRequestedAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { FormattedAddress } from '@ordersnproducts/modules/shared/models/FormattedAddress.interface';

export interface IPointOfDeliveryState {
  required: boolean;
  disabled: boolean;
  loaded: boolean;
  visible: boolean;
  loading: boolean;
  pointOfDeliveries: IShipmentLocation[];
  selected: IShipmentLocation;
  address: IAddress | IRequestedAddressResponse;
  pointOfDeliverySalesArea: IPointOfDeliverySalesArea[];
  showRequestedPointOfDeliveries: boolean;
  createdPointOfDelivery?: any;
  errorPointOfDelivery?: any;
  /**
   * An object which holds formatted addresses where
   * `addressId` is a key and `FormattedAddress` is a value
   */
  addressNames?: {[addressId: number]: FormattedAddress};
}

export const initialState: IPointOfDeliveryState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  pointOfDeliveries: [],
  selected: null,
  address: null,
  pointOfDeliverySalesArea: [],
  showRequestedPointOfDeliveries: true,
  createdPointOfDelivery: null,
  errorPointOfDelivery: null,
  addressNames: null,
};

export function pointOfDeliveryReducer(state = initialState, action: PointOfDeliveryActions): IPointOfDeliveryState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const podInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: podInitialState.disabled,
          required: podInitialState.required,
          visible: podInitialState.visible,
        } as IPointOfDeliveryState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case LOAD:
    case LOAD_ADDRESS: {
      return {
        ...state,
        loading: true,
      } as IPointOfDeliveryState;
    }
    case LOAD_COMPLETE: {
      const shipmentLocations: IShipmentLocation[] = action.payload.shipmentLocations;
      return {
        ...state,
        loaded: true,
        loading: false,
        pointOfDeliveries: shipmentLocations,
      } as IPointOfDeliveryState;
    }

    case REMOVE_SELECTED_POD: {
      return {
        ...state,
        selected: null,
        address: null,
      } as IPointOfDeliveryState;
    }

    case POINT_OF_DELIVERY_SET: {
      return {
        ...state,
        selected: action.payload,
      } as IPointOfDeliveryState;
    }
    case LOAD_ADDRESS_SUCCESS: {
      return {
        ...state,
        loading: false,
        address: action.payload,
      } as IPointOfDeliveryState;
    }
    case LOAD_SALES_AREA_SUCCESS: {
      return {
        ...state,
        pointOfDeliverySalesArea: action.payload,
      } as IPointOfDeliveryState;
    }
    case POD_SET_AVAILABILITY: {
      return {
        ...state,
        disabled: action.payload,
      } as IPointOfDeliveryState;
    }
    case TOGGLE_SHOWING_POD_REQUESTS: {
      return {
        ...state,
        showRequestedPointOfDeliveries: action.payload,
      };
    }
    case NEW_POINT_OF_DELIVERY_CREATED: {
      return {
        ...state,
        createdPointOfDelivery: action.payload,
        errorPointOfDelivery: null,
      };
    }
    case POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS: {
      return {
        ...state,
        createdPointOfDelivery: action.payload,
        errorPointOfDelivery: null,
      };
    }
    case NEW_POINT_OF_DELIVERY_FAIL: {
      return {
        ...state,
        createdPointOfDelivery: null,
        errorPointOfDelivery: action.payload,
      };
    }
    case RESET_NEW_POINT_OF_DELIVERY: {
      return {
        ...state,
        createdPointOfDelivery: null,
        errorPointOfDelivery: null,
      };
    }
    case PONT_OF_DELIVERY_DELETE_BY_ID: {
      return {
        ...state,
        pointOfDeliveries: state.pointOfDeliveries.filter((pod) => pod.shipmentLocationId !== action.payload),
      };
    }
    case LOAD_ADDRESS_NAMES_SUCCESS: {
      return {
        ...state,
        addressNames: action.payload.reduce((acc, item) => {
          acc[item.addressId] = item;
          return acc;
        }, {}),
      };
    }
    case ADDRESS_NAMES_ADD_ENTITY: {
      return {
        ...state,
        addressNames: {[action.payload.addressId]: action.payload, ...state.addressNames},
      };
    }
    default: {
      return state;
    }
  }
}
